export type CookieProps = {
	secure?: boolean;
	expires?: Date;
	path?: string;
	domain?: string;
};

export function setCookie(
	name: string,
	value: string,
	{ expires, path = '/', secure = false, domain }: CookieProps = {}
): void {
	const cookie: CookieProps = { [name]: value, path, secure, expires, domain };

	if (typeof window === 'undefined') return;

	document.cookie = Object.entries(cookie)
		.map(([name, value]) => {
			let leftSide = `${name}`;
			let rightSide = '';

			if (value) {
				if (typeof value === 'string') {
					rightSide = `=${value}`;
				} else if (value instanceof Date) {
					rightSide = `=${value.toUTCString()}`;
				}
			} else {
				leftSide = '';
			}

			return `${leftSide}${rightSide}`;
		})
		.filter(Boolean)
		.join('; ');
}

export function removeCookie(name: string) {
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

export function getCookie(name: string): string | null {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts?.pop()?.split(';').shift() ?? null;
	return null;
}
